export const LANDING = '/Football-app/';
export const SIGN_UP = '/Football-app/signup';
export const SIGN_IN = '/Football-app/signin';
export const ACCOUNT = '/Football-app/account';
export const ADMIN = '/Football-app/admin';
export const PASSWORD_FORGET = '/Football-app/pw-forget';
export const LEAGUE = '/Football-app/standings/:league';
export const TEAM = '/Football-app/teams/:team';